import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterResults' })
export class FilterResultsPipe implements PipeTransform {

  transform(value: any[], filter: any): any[] {
    if (!value || value.length === 0 || !filter) {
      return value;
    }

    const firstItem = value[0];
    if (!firstItem.hasOwnProperty('id') && !firstItem.hasOwnProperty('makeId') && firstItem.hasOwnProperty('content')) {
      return this.filterGroupedData(value, filter);
    }

    if (firstItem.hasOwnProperty('makeId')) {
      return this.filterErrorReports(value, filter);
    }

    return this.filterGenericData(value, filter);
  }

  private filterGroupedData(value: any[], filter: any): any[] {
    const processed = value.map(section => {
      let filteredContent = section.content || [];

      if (filter.group) {
        filteredContent = filteredContent.filter((b: any) => {
          const id = b.bulletinDisplayId || b.mainGroupId;
          return id && id.substr(0, 2) === filter.group;
        });
      }

      if (filter.series) {
        filteredContent = filteredContent.filter((b: any) =>
          b.series?.some((s: any) => s.seriesName.toLowerCase() === filter.series.toLowerCase())
        );
      }

      if (filter.from || filter.to) {
        filteredContent = filteredContent.filter((b: any) => this.checkYearRange(b.releaseDate, filter.from, filter.to));
      }

      return { ...section, content: filteredContent };
    });
    return processed;
  }

  private filterErrorReports(value: any[], filter: any): any[] {
    let result = [...value];

    if (filter.brand) {
      result = result.filter(item => item.makeId === filter.brand);
    }

    if (filter.from) {
      result = result.filter(item => item.insertTS >= filter.from);
    }

    if (filter.to) {
      result = result.filter(item => item.insertTS <= filter.to);
    }

    return result;
  }

  private filterGenericData(value: any[], filter: any): any[] {
    let result = [...value];

    if (filter.engine) {
      result = result.filter(item =>
        item.engineFamily?.toLowerCase().includes(filter.engine.toLowerCase())
      );
    }

    if (filter.year) {
      result = result.filter(item =>
        item.productionDate === filter.year || item.productionDate?.includes(filter.year)
      );
    }

    if (filter.hasOwnProperty('location') || filter.hasOwnProperty('models')) {
      Object.keys(filter).forEach(key => {
        if (!filter[key]) return;

        if (key === 'models') {
          result = result.filter(report =>
            report.models?.some((m: any) => m.modelName.toLowerCase() === filter.models.toLowerCase())
          );
        } else if (key === 'series') {
          result = result.filter(report =>
            report.series?.some((s: any) => s.seriesName.toLowerCase() === filter.series.toLowerCase())
          );
        } else if (key !== 'location') {
          result = result.filter(tool =>
            tool[key] != null && tool[key].toString().toLowerCase().includes(filter[key].toString().toLowerCase())
          );
        }
      });
    }

    if (filter.group) {
      result = result.filter(item => {
        const id = item.bulletinDisplayId;
        return id && id.substr(0, 2).trim() === filter.group;
      });
    }

    if (filter.series && !filter.hasOwnProperty('location')) {
      result = result.filter(item => {
        if (item.series && Array.isArray(item.series)) {
          return item.series.some((s: any) => {
            const matchSeries = s.seriesName.toLowerCase() === filter.series.trim().toLowerCase();
            if (filter.body && matchSeries) {
              return s.bodies?.some((type: any) => type.bodyName.toLowerCase() === filter.body.toLowerCase());
            }
            return matchSeries;
          });
        }
        return false;
      });
    }

    if (filter.body && !filter.series) {
      result = result.filter(item =>
        item.series?.some((s: any) => s.bodies?.some((b: any) => b.bodyName.toLowerCase() === filter.body.toLowerCase()))
      );
    }

    if (filter.from || filter.to) {
      result = result.filter(item => this.checkYearRange(item.releaseDate, filter.from, filter.to));
    }

    return result;
  }

  private checkYearRange(dateStr: string, from?: any, to?: any): boolean {
    if (!dateStr) return false;

    const itemDate = new Date(dateStr);
    if (isNaN(itemDate.getTime())) return false;

    const itemYear = itemDate.getFullYear();

    const fromYear = from ? parseInt(from, 10) : null;
    const toYear = to ? parseInt(to, 10) : null;

    if (fromYear && itemYear < fromYear) return false;
    if (toYear && itemYear > toYear) return false;

    return true;
  }
}